export const mutations = {
  STORE_PAYMENTS(state, payments) {
    state.payments = payments;
  }
};
export default mutations;



// WEBPACK FOOTER //
// ./src/vuex/modules/payments/mutations.js